<template>
  <div class="pa-7" id="summary">
   <!--タイトル-->
    <span class="subHead">
    {{ title }}
    </span>
    <v-icon
    class="mb-2"
    color="blue-grey darken-2">
      {{ icon }}
    </v-icon>
    <!--内容-->
 <div class="row">
<v-col>
 <v-card-text class="summary" style="white-space:pre-wrap; word-wrap:break-word; margin-top:-1rem;">
                {{ description }}
          </v-card-text>
          </v-col>
</div>
</div>
</template>

<style>
.subHead {
  font-size: 25px;
}
.head2 {
  font-size: 20px;
  border-left: inset 6px#99CCFF;
  padding-left: 8px;
  margin-bottom: 8px;
}
.summary {
  vertical-align: middle;
  font-size: 16px;
}
</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: '概要',
      // タイトル横のアイコン
      icon: 'mdi-message-bulleted',
      // 説明文
      description: `
研究開発では、静止衛星を用いた高遅延環境での動画配信の効率的なプロトコルの調査、e-Learningシステムのヒューリスティック評価、アンケート評価、アクセスログを用いたユーザビリティの改善、ニューラルネットによる医用画像セグメンテーションのGPUを用いた高速化などを行い、研究開発から得られた成果をソフトウェア開発にフィードバックしています。`
    }
  }
}
</script>
